const SELECTSERVICE_UPDATED = (state, SelectService) => {
  state.SelectService = SelectService
}
const REBOOK_GET = (state, Rebook) => {
  state.Rebook = Rebook
}
const FLIGHTHISTORY_GET = (state, FlightHistory) => {
  state.FlightHistory = FlightHistory
}
const PAXSGROUP_UPDATED = (state, PaxsGroup) => {
  state.PaxsGroup = PaxsGroup
}
export default {
  SELECTSERVICE_UPDATED,
  REBOOK_GET,
  FLIGHTHISTORY_GET,
  PAXSGROUP_UPDATED
}
